import { getTechnologyFilter } from 'domain/shared/career';
import type { Technology } from 'domain/shared/career';
import { EDUCATION_SPECIALIST_ID, SOFTWARE_ENGINEER_ID } from 'domain/shared/employee';

const SPECIALIZATION_POSITION_IDS: Dictionary<number> = {
  'Software Engineer': SOFTWARE_ENGINEER_ID,
  'Education Specialist': EDUCATION_SPECIALIST_ID,
};

export const getTechnologyNameFilter = (specialization?: string) => {
  const technologyFilter = getTechnologyFilter(SPECIALIZATION_POSITION_IDS[specialization ?? '']);

  if (!technologyFilter) {
    return undefined;
  }

  return (technologies: Technology[]) =>
    Object.values(technologyFilter(technologies)).reduce(
      (result, technologyName) => ({ ...result, [technologyName]: technologyName }),
      {} as Dictionary<string>,
    );
};
